/* eslint-disable react/no-unknown-property */
import EarthAndSatelliteScene from '../3D/EarthAndSatelliteScene'; // 3D 시각화 컴포넌트 (위성 클릭 모달 포함)
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { Text, SelectBox } from 'components';
import { useState, useEffect } from 'react';
import axios from 'common/AxiosAuth';
import { ListType } from 'types/selectbox';

type Props = {
  latestSpacecrafts?: any[];
};

export const EarthOrbitSection = ({ latestSpacecrafts }: Props) => {
  const [selectedGroundStation, setSelectedGroundStation] = useState<number | string>('');
  const [groundStations, setGroundStations] = useState<any[]>([]);
  const [options, setOptions] = useState<ListType[]>([]);

  // 지상국 데이터 가져오기
  useEffect(() => {
    const fetchGroundStations = async () => {
      try {
        const response = await axios.get('/api/groundstation/listAll');
        const stations = response.data;
        setGroundStations(stations);
        
        // 셀렉트 박스 옵션 생성
        const list: ListType[] = stations.map((station: any) => ({
          label: station.name,
          value: station.id  // groundStationId 대신 id 사용
        }));
        setOptions(list);

        // "SACHEON A/T" 지상국을 기본 선택
        if (list.length > 0) {
          // "SACHEON A/T" 지상국 찾기
          const sacheonStation = stations.find((station: any) => station.name === 'SACHEON A/T');
          const targetStation = sacheonStation || stations[0]; // 없으면 첫 번째 지상국 사용
          
          const targetGroundStationId = targetStation.id;
          console.log('기본 선택 지상국:', targetStation.name, 'ID:', targetGroundStationId);
          setSelectedGroundStation(targetGroundStationId);
          
          // 3D 컴포넌트에 선택된 지상국 이벤트 전달
          if (targetStation) {
            const event = new CustomEvent('groundStationSelected', { 
              detail: { stationName: targetStation.name } 
            });
            window.dispatchEvent(event);
          }
        }
      } catch (error) {
        console.error('지상국 데이터 조회 실패:', error);
      }
    };

    fetchGroundStations();
  }, []);

  // 지상국 선택 핸들러
  const handleGroundStationSelect = (value: number | string) => {
    console.log('지상국 선택됨:', value);
    setSelectedGroundStation(value);
    const selectedStation = groundStations.find(station => station.id === value);
    console.log('선택된 지상국:', selectedStation);
    if (selectedStation) {
      // 3D 컴포넌트에 선택된 지상국 이름 전달
      const event = new CustomEvent('groundStationSelected', { 
        detail: { stationName: selectedStation.name } 
      });
      window.dispatchEvent(event);
    }
  };

  return (
    <div className="relative h-full w-full rounded-xl border border-border-primary bg-bg-layer3 p-4">
      <div className="mx-auto flex w-full h-full flex-col items-center">
        {/* 3D 시각화 컴포넌트를 렌더링합니다. */}
        {selectedGroundStation ? (
          <Canvas className="h-full w-full" camera={{ position: [0, 0, 30], fov: 60 }}>
            <ambientLight intensity={0.5} />
            <pointLight position={[10, 10, 10]} />
            <OrbitControls 
              enablePan={true}
              enableZoom={true}
              enableRotate={true}
              minDistance={15}
              maxDistance={150}
            />
            <EarthAndSatelliteScene
              latestSpacecrafts={latestSpacecrafts} 
              onGroundStationSelect={handleGroundStationSelect}
              groundStations={groundStations}
              selectedGroundStation={selectedGroundStation}
            />
          </Canvas>
        ) : (
          <div className="flex items-center justify-center h-full">
            <div>Loading...</div>
          </div>
        )}
        {/* 디버깅용 로그 */}
        {/* <div style={{position: 'absolute', top: '10px', left: '10px', background: 'white', padding: '5px', fontSize: '12px'}}>
        Selected ground station ID: {selectedGroundStation}
        </div> */}
        {/* 지상국 셀렉트 박스 */}
        <div className="absolute left-1/2 top-4 flex items-center gap-2 translate-x-[-50%]">
          {options.length > 0 ? (
            <SelectBox
              list={options}
              label=""
              value={selectedGroundStation}
              setValue={handleGroundStationSelect}
              bgColor="layer2"
              className="w-32 lg:w-48"
            />
          ) : (
            <div className="bg-bg-layer2 px-4 py-2 rounded-lg border border-border-primary w-32 lg:w-48">
              <Text size="body2" weight="medium" color="primary">
                Loading...
              </Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
